export default __webpack_public_path__ + "static/media/endorser.19dd1fb0.jpg";